import Helper from "@/services/Helper"

export default class ConvertQuery {
    static handle(query) {
        let q = {}

        if (query["search"] !== "") {
            q = Helper.mergeObject(q, {
                "search": query["search"],
            })
        }

        if (query["date"]["from"] !== null) {
            q = Helper.mergeObject(q, {
                "created_at_from": query["date"]["from"],
            })
        }

        if (query["date"]["to"] !== null) {
            q = Helper.mergeObject(q, {
                "created_at_to": query["date"]["to"],
            })
        }

        if (query["users"]?.length > 0) {
            q = Helper.mergeObject(q, {
                "user_ids": query["users"],
            })
        }

        if (query["categories"]?.length > 0) {
            q = Helper.mergeObject(q, {
                "category_ids": query["categories"],
            })
        }

        if (query["is_moderate"] !== undefined && query["is_moderate"] !== null) {
            q = Helper.mergeObject(q, {
                "is_moderate": query["is_moderate"],
            })
        }

        if (query["themes"]?.length > 0) {
            q = Helper.mergeObject(q, {
                "theme_ids": query["themes"],
            })
        }

        if (query["wishlists"]?.length > 0) {
            q = Helper.mergeObject(q, {
                "wishlist_ids": query["wishlists"],
            })
        }

        if (query["delst"] !== null && query["delst"] !== undefined) {
            q = Helper.mergeObject(q, {
                "wish_delst": query["delst"],
            })
        }

        return Helper.mergeObject(q, {
            "limit": query["limit"],
            "offset": query["offset"],
        })
    }
}